<script>
import Layout from "@layouts/form";
import TabelaCalculo from "@forms/TabelaCalculo";

export default {
  page: {
    title: "Detalhes | TabelaCalculo"
  },
  components: { Layout, TabelaCalculo },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Tabela de Cálculo",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Tabela de Cálculo",
          href: "/TabelaCalculo"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <TabelaCalculo :editable="editable"></TabelaCalculo>
    </div>
  </Layout>
</template>
